import React from 'react';
import Component from '@plone/volto/components/theme/Component/Component';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { PersonIcon, PhoneIcon, ArrowRightIcon } from '../SiteChrome/icons';

// Reference Contact card; the record supplies each independent way to get in touch.
export default function ContactCard({ item, isEditMode }) {
  return (
    <article className="bonn-entry bonn-contact">
      {item.image_field ? (
        <Component
          componentName="PreviewImage"
          item={item}
          alt=""
          className="bonn-contact-portrait"
          loading="lazy"
          responsive
        />
      ) : (
        <div
          className="bonn-contact-portrait bonn-contact-generic"
          aria-hidden="true"
        >
          <PersonIcon size={56} />
        </div>
      )}
      <div className="bonn-entry-body">
        <h3 className="bonn-contact-name">{item.title || item.id}</h3>
        {item.email && (
          <div className="bonn-contact-email">
            <ConditionalLink
              href={`mailto:${item.email}`}
              condition={!isEditMode}
            >
              {item.email}
            </ConditionalLink>
          </div>
        )}
        {item.phone && (
          <div className="bonn-contact-phone">
            <ConditionalLink
              href={`tel:${item.phone.replace(/[^\d+]/g, '')}`}
              condition={!isEditMode}
            >
              <PhoneIcon size={20} />
              {item.phone}
            </ConditionalLink>
          </div>
        )}
        {item.description && (
          <p className="bonn-contact-text">{item.description}</p>
        )}
        {item.contact_url && (
          <div className="bonn-contact-link">
            <ConditionalLink href={item.contact_url} condition={!isEditMode}>
              Mehr Info &amp; Kontakt
              <ArrowRightIcon size={16} />
            </ConditionalLink>
          </div>
        )}
        {item.image_field && item.copyright && (
          <div className="bonn-contact-copyright">© {item.copyright}</div>
        )}
      </div>
    </article>
  );
}
